import { render } from "./Organisation.CreditReceiptsDatatable.vue?vue&type=template&id=6f9c36be"
import script from "./Organisation.CreditReceiptsDatatable.vue?vue&type=script&lang=js"
export * from "./Organisation.CreditReceiptsDatatable.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__